import { Injector, Injectable } from '@angular/core';
import { FilterableService } from '../../filterable-service';
import { DocumentService, AuthorizationService } from '../../ve.service';
import { FileInfo, FileState } from '@progress/kendo-angular-upload';
import { saveAs } from '@progress/kendo-file-saver';
import { WorkOrdersService } from '../work-orders.service';

@Injectable()
export class FileUploadService {
    documentService: DocumentService;
    workOrderService: WorkOrdersService;
    authService: AuthorizationService;
    documentTypesList = new FilterableService();
    documentsList = new FilterableService();
    kendoFileList: Array<FileInfo>;
    uploadSaveUrl: string;
    fileType: string;
    workOrderId: any;
    addInfoCategoryId: any;

    constructor(injector: Injector) {
        this.documentService = injector.get(DocumentService);
        this.workOrderService = injector.get(WorkOrdersService);
        this.authService = injector.get(AuthorizationService);
    }

    getFiles(): Promise<any> {
        return this.getDocumentTypes().then(() => this.getDocuments());
    }

    private getDocumentTypes(): Promise<any> {
        return this.documentService.read('/GetDocumentTypes')
            .then(result => {
                this.documentTypesList.next(result);
            });
    }

    public getDocuments(): Promise<any> {
        const fileTypeId = this.documentTypesList.filteredData.value.filter(element => element.Name === this.fileType)[0].Id;
        return this.documentService.read(`/GetByDocType?workOrderId=${this.workOrderId}&docTypeId=${fileTypeId}`)
            .then(result => {
                if (this.fileType === 'AditionalInfo') {
                    result = result.filter(item => item.AddInfoCategoryId === this.addInfoCategoryId);
                }
                this.documentsList.next(result);
                this.mapDocumentsToKendoComponent();
            });
    }

    handleUploadEvent = (e) => {
        e.headers = e.headers.append('Authorization', this.authService.getAuthToken());

        if (e.files.length > 0) {
            const lastAddedFile = e.files[e.files.length - 1];
            const documentType = (this.documentTypesList.filteredData.value.length > 0) ?
                this.documentTypesList.filteredData.value.filter(element => element.Name === this.fileType)[0] : null;

            e.data = {
                DocumentName: lastAddedFile.name,
                Description: documentType.Name,
                WorkOrderId: this.workOrderId,
                DocumentTypeId: documentType.Id
            };

            if (this.fileType === 'AditionalInfo') {
                e.data.AddInfoCategoryId = this.addInfoCategoryId;
            }
        }
    }

    handleDeleteEvent = (e) => {
        const element = e.target;

        if (element) {
            const documentId = element.getAttribute('data-document-id');
            if (documentId) {
                this.documentService.remove(`?documentId=${documentId}`)
                    .then(() => { this.getDocuments(); });
            }
        }
    }

    handleClickEvent = (e) => {
        const element = e.target;

        if (element) {
            const documentId = element.getAttribute('data-document-id');
            const documentName = element.getAttribute('data-document-name');
            if (documentId) {
                this.documentService.documentDownload(`/Downloadfile?documentId=${documentId}`)
                    .then(blob => { saveAs(blob, documentName); });
            }
        }
    }

    mapDocumentsToKendoComponent() {
        this.kendoFileList = [];
        const documents = this.documentsList.value;

        if (documents) {
            this.documentsList.value.forEach(element => {
                const kendoFile: FileInfo = {
                    name: element.Name || '',
                    uid: element.Id,
                    state: FileState.Uploaded
                };
                this.kendoFileList.push(kendoFile);
            });
        }
    }

    isDisabled() {
        return this.workOrderService.isViewOnlyWO;
    }
}
